/**
 * <strong>Purpose:</strong> <br>
 * Provides the ability to display an icon either via a data-uri or a CSS class. When its given a data-uri, it detects
 * the height and width and sets the iconNode to these dimensions. It also emits an event after the icon image has been
 * applied. When its given a CSS class, the user will need to specify CSS properties on how the icon image should be
 * applied i.e. height, width, background-image
 * <br><br>
 * <strong>Contract:</strong> <br>
 * <em>Attach-point:</em> iconNode <br>
 * The Mixin applies the image to the iconNode attach-point
 *
 * @module MW/toolstrip/mixins/property/IconMixin
 *
 * @copyright Copyright 2019 The MathWorks, Inc.
 */
define([
    "dojo/_base/declare"
], function (declare) {

    return declare(null, {

        _updateDOM: function (value) {
            // Remove previous icon
            this._removeOldIcon();

            // Apply the new icon
            this._applyNewIcon(this._getIconForDOM());
        },

        // g1932099: We have been trying to prevent knowledge of other mixins inside our mixins, but
        // that seems to be quite difficult with regards to IconMixin, so we will have a master switch in iconMixin
        // TODO: In the future we could also incorporate OrientaionMixin and UseQuickAccessIconMixin to get rid of iconProp
        _getIconForDOM: function () {
            if (this.hasOwnProperty("iconOverride") && (this.iconOverride !== "")) {
                return this.iconOverride;
            } else if (this.hasOwnProperty("iconProp") && (this.iconProp !== "") && this[this.iconProp]) {
                return this[this.iconProp];
            } else if ((this.icon === "") && this.hasOwnProperty("quickAccessIcon") && (this.quickAccessIcon !== "")) {
                return this.quickAccessIcon;
            } else {
                return this.icon;
            }
        }

    });

});
